import './index.less'
import CommentItem from '../CommentItem'

interface IProp {
  childrenItems: any[],
  type: "faq" | "notice" | "feedback";
  questionId: string;
  afterDelete?: (id: string) => void;
  afterSend?: (questionId: string, parentId: string) => void;
  handleReport?: (id: string) => void;
}
const CommentChildren = ({childrenItems = [], type, questionId, afterDelete, afterSend, handleReport}: IProp) => {
  const childProps = {
    type,
    questionId,
    afterDelete,
    afterSend,
    handleReport,
    classNames: 'children-item',
  }

  const renderChildren: any = (list: any[]) => {
    return list.map((item: any) => {
      if (item.children.length) {
        return <>
          <CommentItem item={item} key={`${item.id}-children-item`} {...childProps} />
          <div className='children-indent' key={`${item.id}-children-indent`}>
            { renderChildren(item.children) }
          </div>
        </>
      } else {
        return <CommentItem item={item} key={item.id} {...childProps} />
      }
    })
  }

  return <div className='comment-children-content'>
    <div className='comment-children-content-header'>
      <span>{`${childrenItems.length}条评论`}</span>
    </div>
    <div className='comment-children-content-main'>
      { renderChildren(childrenItems) }
    </div>
  </div>
}

export default CommentChildren;